import { type Enum } from '@webapp/infrastructure/types/Enum'

export const OrderItemBlanketReceiveMethods = {
  QUANTITY: 0,
  CURRENCY_AMOUNT: 1,
} as const

export type OrderItemBlanketReceiveMethodEnum = Enum<
  typeof OrderItemBlanketReceiveMethods
>
